import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchMe } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("hb_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    fetchMe()
      .then((u) => setUser(u))
      .catch(() => {
        localStorage.removeItem("hb_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const signIn = (token, u) => {
    localStorage.setItem("hb_token", token);
    setUser(u);
  };
  const signOut = () => {
    localStorage.removeItem("hb_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
